import { render, staticRenderFns } from "./CardTypeList.vue?vue&type=template&id=20acd8fa&scoped=true&lang=pug&"
import script from "./CardTypeList.vue?vue&type=script&lang=ts&"
export * from "./CardTypeList.vue?vue&type=script&lang=ts&"
import style0 from "./CardTypeList.vue?vue&type=style&index=0&id=20acd8fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20acd8fa",
  null
  
)

export default component.exports